import React from 'react';
import { handleSignIn } from '../../Scripts/SignIn';

export default function Home({ loggedInUser }) {

    let content;

    if (!loggedInUser?.loading) {
        let loginButton = !loggedInUser?.isAuthenticated &&
            (<div><button className="button" onClick={() => handleSignIn("/b2r")}>Sign In</button></div>);

        content = (<div className="welcomeScreen">
            <div className="welcome">
                <h1>Welcome to Docshare</h1>
                <div className="font-bold">Access your documents in one of the following ways:</div>
                <br />
                <div className="instructions">1 - Use the link provided in your email along with the access code.</div>
                <div className="instructions">2 - Create an account using the provided link, and sign in with your new account.</div>
                <div className="instructions">3 - If you already have an account, simply sign in.</div>
            </div>
            <div className="signIn">
                <div>
                    <div className="font-bold">Sign into your account</div>
                    <div>Sign in with your D.R. Horton account</div>
                </div>
                <br />
                {loginButton}
            </div>
        </div>);
    }

    return (content);
}
